const entities =  [
    {
        path: '/entities',
        name: 'entities.index',
        component: () => import('@/pages/Entity/IndexPage.vue'),
        meta: {
            requiresAuth: true,
            need_project: false,
            layout: 'content',
            title: "Foydalanuvchilar",
        }
    },
    {
        path: '/real/entities',
        name: 'entities.index.real',
        component: () => import('@/pages/Entity/RealIndexPage.vue'),
        meta: {
            requiresAuth: true,
            need_project: false,
            layout: 'content',
            title: "Foydalanuvchilar",
        }
    },
    {
        path: '/entities/create',
        name: 'entities.create',
        component: () => import('@/pages/Entity/CreatePage.vue'),
        meta: {
            need_project: false,
            requiresAuth: true,
            layout: 'content',
            title: "Foydalanuvchi yaratish",
        }
    },
    {
        path: '/entities/individual/:id/show',
        name: 'entities.individual.show',
        component: () => import('@/pages/Entity/EditPage.vue'),
        meta: {
            need_project: false,
            requiresAuth: true,
            layout: 'content',
            title: "Foydalanuvchi yaratish",
        }
    },
    {
        path: '/entities/legal/:id/show',
        name: 'entities.legal.show',
        component: () => import('@/pages/Entity/LegalEditPage.vue'),
        meta: {
            need_project: false,
            requiresAuth: true,
            layout: 'content',
            title: "Foydalanuvchi yaratish",
        }
    },
]

export default entities